export default __webpack_public_path__ + "static/media/cofactr_icon_logo.8bd655d5.svg";